<template>

<com-item name="games.overview" :size="size" :is-overview="3" :loading="loading" :is-empty="!active" title="Overview">

	<template v-slot:about>

		<p>{{ your | capitalise }} universe at a glance.</p>

	</template>

	<template v-slot:stats>

		<com-overview label="Games" type="number" :value="data.totalTouched" />

		<com-overview label="New This Year" type="number" :value="data.newThisYear" />

		<com-overview label="Avg. Encounters" type="number" :value="data.avgMonthly" :empty="!data.avgMonthly" :valueLabel="'per month'" />

		<com-overview label="Unrated" type="percent" :value="data.unratedPercent" :empty="!data.totalTouched" />

		<com-overview label="Avg. Rating" type="rating" :value="data.avgRating" :empty="!data.avgRating" />

		<com-overview label="Unplayed" type="percent" :value="data.unplayedPercent" :empty="!data.totalTouched" />

		<com-overview label="Avg. Plays" type="number" :value="data.avgPlays" :empty="!data.avgPlays" :valueLabel="'per game'" />

		<com-overview label="Fresh Games" type="number" :value="data.fresh" />

		<com-overview label="Stale Games" type="number" :value="data.stale" />

	</template>

</com-item>

</template>

<script>

import comOverview from './../common/Overview'
import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-overview': comOverview
	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/games/overview']

		},

		active: function() {

			return this.data && !this.loading && Object.keys(this.data).length

		}

	}

}

</script>

<style scoped>

</style>
